import { EmptyComponent } from "../common/EmptyComponent";
import Loadable from "react-loadable";

export const RightSideDrawer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "drawer/right-side" */ "./RightSideDrawer"),
  loading: EmptyComponent
});
